var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.poi && _vm.getOpeningHours())?_c('div',[_c('div',{staticClass:"text-h6"},[_vm._v("Öffnungszeiten")]),_c('div',{staticClass:"text-body-2"},[_vm._v(_vm._s(_vm.getOpeningHours()))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }